// IL QUARTIERE SI SCEGLIE, NON SI INDOVINA.
//
// Il geocoder chiama «quartiere» quello che gli capita: per un indirizzo di
// Crown Heights dava «Brooklyn» (il borough), a Manhattan «Manhattan Community
// Board 7» (un distretto amministrativo). Ogni scheda aggiunta col pin portava
// nel filtro una voce nuova e sbagliata accanto a quelle giuste.
//
// Così il campo propone i quartieri che la città HA GIÀ, e resta scrivibile
// per quando ne serve davvero uno nuovo. E quando si sceglie
// un indirizzo dalla mappa, il quartiere si riempie solo se il geocoder ne
// nomina uno che la città ha già; altrimenti resta quello di prima.
import React, { useEffect, useState } from 'react';
import ComboBox from './ComboBox';
import { api } from './api';
import { t } from './i18n';

const fold = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '')
  .toLowerCase().replace(/[^a-z0-9֐-׿]+/g, ' ').trim();

const sortedAreas = (rows) => [...new Set((rows || []).map((x) => x.area).filter(Boolean))]
  .sort((a, b) => a.localeCompare(b));

// I quartieri che la città ha già, per il menu.
export function useAreaOptions(city, country) {
  const [opts, setOpts] = useState([]);
  useEffect(() => {
    if (!city) { setOpts([]); return undefined; }
    let alive = true;
    api.areas({ city, country })
      .then((r) => { if (alive) setOpts(sortedAreas(r)); })
      .catch(() => { if (alive) setOpts([]); });
    return () => { alive = false; };
  }, [city, country]);
  return opts;
}

// New York: il sito tiene Brooklyn, Queens, Staten Island e il Bronx come città
// a sé (Brooklyn 160 schede, Queens 114). Il geocoder dice «New York» e mette il
// borough fra i quartieri: lo si riporta alla città.
const BOROUGH = { brooklyn: 'Brooklyn', queens: 'Queens', 'staten island': 'Staten Island', bronx: 'Bronx', 'the bronx': 'Bronx' };

// Città e quartiere da un indirizzo scelto sulla mappa. Il quartiere viene
// solo dai nomi che quella città ha già nel sito.
export async function cityAndAreaFromPick(parts, current) {
  const p = parts || {};
  const cands = [...(Array.isArray(p.areas) ? p.areas : []), p.area].filter(Boolean);
  let city = p.city || current.city || '';
  if (/^new york(?: city)?$/i.test(city.trim())) {
    const b = cands.map((c) => BOROUGH[fold(c)]).find(Boolean);
    if (b) city = b;
  }
  const sameCity = fold(city) === fold(current.city);
  let options = sameCity ? (current.options || []) : [];
  if (!sameCity && city) {
    try { options = sortedAreas(await api.areas({ city, country: p.country || current.country })); } catch (e) { options = []; }
  }
  const hit = options.find((o) => cands.some((c) => fold(c) === fold(o)));
  return { city, area: hit || (sameCity ? (current.area || '') : '') };
}

// Si sceglie dall'elenco dei quartieri della città o si scrive a mano: lo
// stesso campo fa tutte e due le cose (ComboBox.js).
export default function AreaPicker({ value, onChange, options, style, placeholder }) {
  return (
    <ComboBox style={style} value={value || ''} onChange={onChange} options={options || []}
      placeholder={(options || []).length ? t('Choose or type a neighbourhood') : (placeholder || t('e.g. Trastevere'))} />
  );
}
